import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import { getMeetingById } from '../../../api/MeetingApi';

const RestaurantCertificatePage = () => {
    const { meetingId } = useParams();
    const [meetingData, setMeetingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchMeetingData();
    }, [meetingId]);

    const fetchMeetingData = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getMeetingById(meetingId);
            setMeetingData(data);
            console.log('식당 인증을 위한 모임 정보:', data);
        } catch (error) {
            console.error('모임 정보 조회 실패:', error);
            setError('모임 정보를 가져올 수 없습니다.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <CommonLayout title="식당 인증">
                <div className="flex items-center justify-center h-64">
                    <div className="text-gray-500">모임 정보를 불러오는 중...</div>
                </div>
            </CommonLayout>
        );
    }

    if (error) {
        return (
            <CommonLayout title="식당 인증">
                <div className="flex flex-col items-center justify-center h-64">
                    <div className="text-red-500 mb-4">{error}</div>
                    <button
                        onClick={fetchMeetingData}
                        className="px-4 py-2 bg-amber-500 text-white rounded-lg"
                    >
                        다시 시도
                    </button>
                </div>
            </CommonLayout>
        );
    }

    return (
        <CommonLayout title="식당 인증">
            {/* 공식 인증서 스타일 - 얇은 이중 테두리(amber-500) */}
            <div className="flex-1 flex items-center justify-center p-4 landscape:p-6 bg-amber-100 overflow-hidden">
                {/* 메인 인증서 컨테이너 */}
                <div className="w-full max-w-4xl h-[calc(100vh-100px)] landscape:h-[calc(100vh-150px)] bg-white rounded-3xl landscape:rounded-4xl p-2 landscape:p-3 border border-amber-500">
                    {/* 내부 흰색 배경 + 두 번째 테두리 */}
                    <div className="w-full h-full bg-white rounded-2xl landscape:rounded-3xl relative p-6 landscape:p-8 border border-amber-500">

                        {/* 상단 안내 문구 */}
                        <div className="absolute top-4 landscape:top-6 left-1/2 transform -translate-x-1/2 text-xs text-gray-500 text-center whitespace-nowrap">
                            본 인증서는 밥친구 앱 내에서만 효력이 있습니다.<br/>사장님께서 인증서를 요청하실 경우 보여주세요.
                        </div>

                        {/* 메인 콘텐츠 */}
                        <div className="flex flex-col landscape:flex-row h-full">
                            <div className="flex-1 flex flex-col justify-center items-center landscape:items-start space-y-4 landscape:space-y-6">
                                {/* 식당명 */}
                                <div className="text-center landscape:text-left">
                                    <h1 className="text-4xl landscape:text-5xl font-black text-gray-800 mb-2 landscape:mb-4">
                                        {meetingData?.placeName || '식당명'}
                                    </h1>
                                    <div className="w-20 landscape:w-28 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-full mx-auto landscape:mx-0"></div>
                                </div>

                                {/* 모임 제목 */}
                                <div className="text-center landscape:text-left">
                                    <h2 className="text-4xl landscape:text-5xl font-black text-gray-800 mb-2 landscape:mb-4">
                                        {meetingData?.title || '모임 제목'}
                                    </h2>
                                    <div className="w-20 landscape:w-28 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-full mx-auto landscape:mx-0"></div>
                                </div>
                            </div>

                            <div className="flex-1 flex flex-col justify-center space-y-4 landscape:space-y-6">
                                {/* 참석 인원 */}
                                <div className="text-center landscape:text-left">
                                    <div className="text-3xl landscape:text-4xl font-black text-gray-800">
                                        {meetingData?.memberCount || 0}명
                                    </div>
                                    <div className="text-sm landscape:text-lg text-gray-600 mt-1">
                                        참석 예정
                                    </div>
                                </div>

                                {/* 모임 시간 */}
                                <div className="text-center landscape:text-left">
                                    <div className="text-3xl landscape:text-4xl font-black text-gray-800">
                                        {meetingData?.scheduledAt ?
                                            new Date(meetingData.scheduledAt).toLocaleDateString('ko-KR', {
                                                month: 'long',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            }) : '시간 미정'
                                        }
                                    </div>
                                    <div className="text-sm landscape:text-lg text-gray-600 mt-1">
                                        모임 일시
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 하단: 밥친구 브랜딩 */}
                        <div className="absolute bottom-4 landscape:bottom-6 left-1/2 transform -translate-x-1/2 flex flex-col landscape:flex-row items-center justify-center space-y-2 landscape:space-y-0 landscape:space-x-4 px-4 whitespace-nowrap">
                            <img
                                src="/images/bapfriend_character03.png"
                                alt="밥친구 캐릭터"
                                className="w-10 landscape:w-14 h-10 landscape:h-14 object-contain"
                            />
                            <div className="text-center landscape:text-left">
                                <div className="text-base landscape:text-lg font-bold text-amber-600">
                                    밥친구
                                </div>
                                <div className="text-xs landscape:text-sm text-gray-500">
                                    밥친구 앱을 통해 만들어진 모임임을 인증합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CommonLayout>
    );
};

export default RestaurantCertificatePage;
